import * as React from "react"
import { Button as SharedButton, buttonVariants } from "@dobbix/ui"
import { cn } from "@/lib/utils"

export const Button = React.forwardRef<HTMLButtonElement, React.ComponentProps<typeof SharedButton>>(
  ({ className, ...props }, ref) => (
    <SharedButton ref={ref} className={cn("rounded-lg", className)} {...props} />
  )
)
Button.displayName = "Button"

export { buttonVariants }
